import { boolLabel, fmtFecha } from "@/lib/format";

// UI-017 — PROYECCIÓN DE LECTURA de `persona.instrucciones`. El renderer anterior sólo pintaba los
// apartados 1, 2, 3, 5, 7, 9 y 11: los apartados 4 (directiva anticipada), 6 (conflicto),
// 8 (acceso al inmueble) y 10 (consentimiento de grabación) quedaban OMITIDOS aunque tuvieran
// valor guardado. Aquí se listan los 11 con las MISMAS claves que escribe el editor.
// Reglas: «No»/false NO es vacío (boolLabel ya distingue Sí / No / Sin contestar); los subcampos
// condicionales sólo se muestran cuando su condición se cumple en el dato (no se infiere
// autorización ni consentimiento); las fechas capturadas viajan como sufijo, nunca como afirmación.

const AUTORIDAD = {
  propia_persona: "La propia persona",
  representante_legal: "Representante legal",
  otra_persona_autorizada: "Otra persona autorizada",
};

export const autoridadLabel = (t) => AUTORIDAD[t] || "Sin definir";

const conFecha = (o) => {
  const base = boolLabel((o || {}).valor);
  const f = (o || {}).fecha;
  return f ? `${base} · ${fmtFecha(f)}` : base;
};

const texto = (v) => (typeof v === "string" && v.trim() ? v : "");

export function filasInstrucciones(instrucciones, { audioNoAplica = false, resolverHibrido } = {}) {
  const ins = instrucciones || {};
  const hib = resolverHibrido || (() => "Sin definir");
  const filas = [];
  const add = (n, label, valor, extra = {}) => filas.push({ n, label, valor, ...extra });

  const aut = ins.autoridad || {};
  add(1, "1. Autoridad (quién decide)",
    `${autoridadLabel(aut.tipo)}${texto(aut.nombre) ? " · " + aut.nombre : ""}${texto(aut.relacion) ? " (" + aut.relacion + ")" : ""}`);
  add(2, "2. Autorización de emergencia", conFecha(ins.autorizacion_emergencia));
  add(3, "3. Si la persona rechaza emergencia", texto(ins.instruccion_rechazo_emergencia), { ancho: true });

  const dir = ins.directiva_anticipada || {};
  add(4, "4. Directiva anticipada / cuidados paliativos", boolLabel(dir.existe));
  if (dir.existe === true) {
    add("4a", "4. Responsable designado", texto(dir.responsable));
    add("4b", "4. Instrucción operativa (el operador sólo lee)", texto(dir.instruccion_operativa), { ancho: true });
  }

  add(5, "5. Titular del protocolo (autoriza cambios)", hib(ins.quien_modifica_protocolo), { destacado: true });
  add(6, "6. En decisiones en conflicto, ¿quién prevalece?", hib(ins.conflicto_familiares));

  const ver = ins.verificador_fisico || {};
  add(7, "7. Verificador físico contratado", boolLabel(ver.contratado));
  if (ver.contratado === true) add("7a", "7. Quién puede autorizar un despacho", hib(ver.autoriza));

  const acc = ins.acceso_inmueble || {};
  add("8a", "8. Caja de llaves (ubicación y código)", texto(acc.ubicacion_codigo_caja));
  add("8b", "8. Caseta de acceso", texto(acc.caseta));
  add("8c", "8. Puertas adicionales", texto(acc.puertas_adicionales));
  add("8d", "8. Mascotas", texto(acc.mascotas));
  add("8e", "8. Obstáculos conocidos", texto(acc.obstaculos));

  add(9, "9. Consentimiento de audio bidireccional",
    audioNoAplica ? "No aplica en este sitio" : conFecha(ins.consentimiento_audio_bidireccional));
  add(10, "10. Consentimiento de grabación de audio", conFecha(ins.consentimiento_grabacion));
  add(11, "11. Confirmación de límites", conFecha(ins.confirmacion_limites));
  return filas;
}
